var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-btn'),_c('v-row',[_c('v-col',{attrs:{"lg":"10","offset-lg":"1"}},[_c('visit-data-view')],1)],1),_c('end-dots-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }